module.exports = __webpack_public_path__ + "static/0037-62e522f55fb50375b9ce4332ff47b414.png";